module.exports = __webpack_public_path__ + "media/images/main_trafficapp-3ccb4ed4.jpg";